import { createContext } from "react";
import useStageSummariesByProjectId from "../hooks/data/useStageSummariesByProjectId";

export interface IStageSummariesContext extends ReturnType<typeof useStageSummariesByProjectId> {

};

const StageSummariesContext = createContext<IStageSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default StageSummariesContext